<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Ataskaitos siuntimas kitiems asmenims</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <v-row class="mb-3">
              <v-col cols="12" md="12">
                <el-button class="mb-3" x-small @click.native="addItem()">
                  Pridėti el. paštą
                </el-button>
              </v-col>
              <v-col cols="12" md="12">
                <div
                  class="pastas"
                  v-for="(pastas, index) in pastai"
                  :key="index"
                >
                  <el-pastas
                    class="my-0 py-0"
                    required
                    :validate-key="`${item.ata_id}-${index}`"
                    :hide-details="true"
                    v-model="pastai[index]"
                  />
                  <el-table-action
                    class="mt-0"
                    :item="{ canDelete: true }"
                    @deleteItem="deleteItem(index)"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button :loading="loading" @click.native.stop="closeModal()">
          Atšaukti
        </el-button>
        <el-button
          :disabled="disabledSiusti"
          :loading="loading"
          primary
          @click.native="saveData()"
        >
          Siųsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalAtaskaitaSendKitas',
  props: {
    value: Boolean,
    item: Object,
  },
  data() {
    return {
      loading: false,
      pastai: [''],
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.pastai = ['']
        this.$validator.reset()
        this.$emit('input', value)
      },
    },
    disabledSiusti() {
      return this.pastai.length === 0
    },
  },
  created() {
    //
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true

          this.loading = false

          this.$emit('confirmSendKitas', {
            item: this.item,
            pastai: this.pastai,
          })
          this.closeModal()
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
    addItem() {
      this.pastai.push('')
    },
    deleteItem(index) {
      this.pastai.splice(index, 1)
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
.pastas {
  width: 100%;
  display: inline-flex;
  white-space: nowrap;
  align-items: flex-start;
  line-height: 40px;
}
</style>
